import React from "react";
import { packClasses } from "Util";

export default function Container(props) {
    const { variant, className, children, ...remainder } = props;
    return (
        <main
            className={packClasses(
                variant === "with-sidebar"
                    ? "lg:col-span-9 xl:col-span-6"
                    : "lg:col-span-9 xl:col-span-10",
                className
            )}
            {...remainder}
        >
            {children}
        </main>
    );
}
